<div class="rubric-dialog">
	<div class="rubric-dialog__header">
		<md-header size="sm">{{ heading() }}</md-header>

		<!-- The weight rides on the tab label so the split across categories is visible at a glance,
		     without having to click through every tab to add them up. -->
		<md-button-group class="rubric-dialog__tabs" [wrap]="true" [value]="selectedTabID()">
			@for (tab of tabs(); track tab.id) {
				<md-button-toggle [value]="tab.id" (change)="selectTab(tab.id)"
					>{{ tab.label }} <span class="rubric-dialog__tab-weight">{{ tab.weightPercent | number: '1.0-2' }}%</span></md-button-toggle
				>
			}
		</md-button-group>

		<button class="close-btn" md-button (click)="close()">
			<md-icon icon="untitled-ui/general/x-close"></md-icon>
		</button>
	</div>

	<div class="rubric-dialog__body">
		@if (selectedTab(); as tab) {
			<div class="rubric-category">
				@if (tab.rubrics.length > 0) {
					<div class="rubric-grid">
						<div class="rubric-grid__header">
							<span>Grade</span>
							<span>Description</span>
						</div>
						@for (rubric of tab.rubrics; track rubric.rubricID) {
							<div class="rubric-grid__row">
								<md-tag [type]="rubric.gradeColor">{{ rubric.gradeName }}</md-tag>
								<span class="rubric-grid__description">{{ rubric.description }}</span>
							</div>
						}
					</div>
				} @else {
					<p class="rubric-category__empty">No rubrics defined for this {{ tabNoun() }}.</p>
				}
			</div>
		} @else {
			<p class="rubric-dialog__empty">Select a {{ tabNoun() }} to view its rubrics.</p>
		}
	</div>

	<md-content-box type="tertiary">
		Instructors may add a plus (+) or minus (–) to any grade. A '+' means the work is slightly better than described. A '–' means it almost meets the
		description but is inconsistent.

		@if (weightNote()) {
			{{ weightNote() }}
		}
	</md-content-box>
</div>
